import { render, staticRenderFns } from "./OvertimeForm.vue?vue&type=template&id=1226bf90&"
import script from "./OvertimeForm.vue?vue&type=script&lang=js&"
export * from "./OvertimeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports